module.exports = __webpack_public_path__ + "static/img/1112.9f2409e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1112.png
// module id = U4dR
// module chunks = 1